import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import {
  EditorState,
} from 'draft-js';
import React, {
  Component,
} from 'react';
import {
  Editor,
} from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Directives from '../../../Directives/Directives';
import generalClasses from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import {
  IRichTextField,
} from '../formFields';
import classes from './RichTextField.module.scss';

interface IProps extends IRichTextField {
  errors: any;
  touched: any;

  onChange(name: string, editorState: EditorState): any;
}

class RichTextField extends Component<IProps> {
  customEditorClassName = {
    maxHeight: 300,
    overflow: 'auto',
    border: '1px solid #dadada',
    minHeight: 100,
    padding: '0 10px',
  };

  config = {
    options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list',
      'textAlign', 'colorPicker', 'link', 'history'],
  };

  onEditorStateChange = (editorState: EditorState) => {
    this.props.onChange(this.props.name, editorState);
  };

  render() {
    return (
      <FormControl className={generalClasses.filed}>
        <div className={classNames(classes.richContainer)}>
          <Typography variant="caption" gutterBottom className={classNames(classes.label)}>
            {this.props.label}
          </Typography>
          <Editor
            editorState={this.props.value}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            editorStyle={this.customEditorClassName}
            onEditorStateChange={this.onEditorStateChange}
            toolbar={this.config}
            handlePastedText={() => false}
          />
        </div>
        <Directives dIf={this.props.errors[this.props.name] && this.props.touched[this.props.name]}>
          <FormHelperText className={generalClasses.error}>{this.props.errors[this.props.name]}</FormHelperText>
        </Directives>
      </FormControl>
    );
  }
}

export default RichTextField;
